import GraphModal from 'graph-modal';
import {modalInfo} from "../_components";

export const form = () => {
    const forms = document.querySelectorAll(".form-block");
    if (!form) return;

    function closeJoinOrJourneyIfOpened() {
        const openedModal = document.querySelector(
            '.graph-modal__container.graph-modal-open'
        );
        console.log(openedModal)
        if (!openedModal) return;

        const target = openedModal.dataset.graphTarget;

        if (target === 'join' || target === 'journey' || target === 'live' || target === 'invest' || target === 'manage') {
            modalInfo.close(target);
        }
    }


    forms.forEach(form => {
        const inputs = form.querySelectorAll("input[required], textarea[required]");
        const telInput = form.querySelector('input[type="tel"]');
        const checkbox = form.querySelector(".politic-checkbox");
        const submitBtn = form.querySelector(".form-block__btn");


        function validateForm() {
            let isValid = true;

            inputs.forEach((input) => {
                if (input.value.trim() === "") {
                    isValid = false;
                }
            });

            const phoneDigits = telInput.value.replace(/\D/g, "");
            if (phoneDigits.length < 5) {
                isValid = false;
            }

            if (!checkbox.checked) {
                isValid = false;
            }

            submitBtn.disabled = !isValid;
        }

        function resetForm(form) {
            setTimeout(() => {
                //form.reset();
            }, 1000);
        }


        form.addEventListener("input", validateForm);
        form.addEventListener("change", validateForm);

        form.addEventListener("submit", (e) => {

            e.preventDefault();
            validateForm();

            if (!submitBtn.disabled) {
                submitBtn.disabled = true;
                // modalInfo.close("join");
                closeJoinOrJourneyIfOpened();
                modalInfo.open("thanks");
                resetForm(form);
            }
        });

    })
};
